//Sets the canvas size based on the aspect ratio of the image and the max width and height of the canvas

//import { genTokenData } from "genkitart/src/utils/helpers";

export class CanvasStore {
  constructor({ scaleOutput, aspectRatio, maxWidth, maxHeight }) {
    this.scaleOutput = scaleOutput ?? this.scaleOutput;
    this.aspectRatio = aspectRatio ?? this.aspectRatio;
    this.maxWidth = maxWidth ?? this.maxWidth;
    this.maxHeight = maxHeight ?? this.maxHeight;
  }

  update({ scaleOutput, canvasWidth, canvasHeight }) {
    this.scaleOutput = scaleOutput ?? this.scaleOutput;
  }
  // Esta es una getter fucntion para que puedas mandar funciones como propiedades
  get renderRatio() {
    return this.scaleOutput * this.canvasDimensions.ratio;
  }
  get scaleMultiplier() {
    return this.scaleOutput;
  }
  get canvasDimensions() {
    //This is a deconstruct for this so you don't have to write this.scaleOutput, this.canvasWidth, etc.
    const { aspectRatio, maxWidth, maxHeight } = this;
    const DEFAULT_SIZE = 1000;
    const ratio = Math.min(maxWidth, maxHeight) / DEFAULT_SIZE;
    let width, height;
    if (aspectRatio > 1) {
      width = Math.min(maxWidth, maxHeight * aspectRatio);
      height = width / aspectRatio;
    } else {
      height = Math.min(maxHeight, maxWidth / aspectRatio);
      width = height * aspectRatio;
    }

    window.WIDTH = width;
    window.HEIGHT = height;

    //console.log(`Canvas size set to ${w} x ${h}`);
    return {
      width: width,
      height: height,
      ratio: ratio,
    };
  }
}

//Exports the canvas as a high resolution image
//Future fix needs to account for the pixel density of the screen
export function exportHighResImage(widthInInches, dpi, p, canvasStore) {
  const { canvasDimensions, scaleOutput } = canvasStore;
  const canvasWidth = widthInInches * dpi;
  const canvasHeight =
    (canvasWidth * canvasDimensions.height) / canvasDimensions.width;
  // Resize the canvas to the desired size
  const newScale = (canvasWidth * scaleOutput) / canvasDimensions.width;
  canvasStore.update({ scaleOutput: newScale });
  p.resizeCanvas(canvasWidth, canvasHeight);
  // Draw the contents of the canvas
  p.draw();
  // Save the canvas as a high-resolution image
  p.saveCanvas(`myImage_${canvasWidth}x${canvasHeight}`, "png");
  canvasStore.update({ scaleOutput: 1 });
  // Restore the canvas to its original dimensions
  p.resizeCanvas(canvasDimensions.width, canvasDimensions.height);
  p.draw();
}
